import { render, staticRenderFns } from "./allClean.vue?vue&type=template&id=0bdd7f3b&scoped=true&"
import script from "./allClean.vue?vue&type=script&lang=js&"
export * from "./allClean.vue?vue&type=script&lang=js&"
import style0 from "./allClean.vue?vue&type=style&index=0&id=0bdd7f3b&lang=scss&scoped=true&"
import style1 from "./allClean.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdd7f3b",
  null
  
)

export default component.exports